// src/docs/DocsSwapLnch.js
import React from "react";
import { Container, Typography } from "@mui/material";

const DocsSwapLnch = () => {
  return (
    <Container maxWidth="md" sx={{ my: 4 }}>
      {/* Title */}
      <Typography variant="h5" sx={{ color: "#FFD700", mb: 2 }}>
        Swap LNCH
      </Typography>

      {/* Introduction */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mb: 2 }}>
        The Swap LNCH feature enables you to exchange LNCH tokens at a fixed rate. This design choice helps maintain stability across the platform and simplifies fee calculations, tokenization, and staking processes.
      </Typography>

      {/* Why Use a Fixed Rate? */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Why a Fixed Rate?
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        Implementing a fixed exchange rate for LNCH provides several key benefits:
        <br /><br />
        • <strong>Stability:</strong> A fixed rate ensures that the cost of fees and tokenization remains predictable, regardless of market volatility.
        <br />• <strong>Consistency in Fee Payment:</strong> LNCH is used to pay fees throughout the platform. With a fixed rate, users know exactly how many tokens are required for each transaction.
        <br />• <strong>Simplified Calculations:</strong> A constant rate makes it easier for both the platform and users to calculate staking rewards and other financial metrics.
      </Typography>

      {/* LNCH Usage Across the Platform */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        LNCH in Platform Operations
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        LNCH plays a central role in the CrowdLaunch ecosystem:
        <br /><br />
        • <strong>Fees:</strong> LNCH is used to pay for tokenization fees and other service charges on the platform. The fixed rate ensures fees remain consistent.
        <br />• <strong>Tokenization:</strong> When launching a project, LNCH tokens are integral to the tokenization process, serving as a base for creating new tokenized assets.
        <br />• <strong>Staking:</strong> Users can stake LNCH tokens to earn rewards. The fixed rate aids in determining staking yields, ensuring a fair and transparent reward calculation.
      </Typography>

      {/* How to Swap LNCH */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        How to Swap LNCH
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        To swap LNCH tokens, follow these steps:
        <br />1. Navigate to the Swap LNCH page.
        <br />2. Enter the amount of LNCH tokens you wish to exchange.
        <br />3. Confirm the swap. The fixed rate will be applied, ensuring you receive a predictable amount in return.
      </Typography>

      {/* Important Considerations */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Important Considerations
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        • <strong>Fixed Rate Benefits:</strong> The fixed rate eliminates surprises due to market fluctuations, making budgeting for fees and staking easier.
        <br />• <strong>Fee Predictability:</strong> With LNCH used as the fee token, knowing the fixed rate helps ensure you always have enough tokens for transactions.
        <br />• <strong>Staking Calculations:</strong> Staking rewards are computed using the fixed rate, promoting consistency and fairness in reward distribution.
      </Typography>

      {/* Troubleshooting */}
      <Typography variant="h6" sx={{ color: "#FFD700", mb: 1 }}>
        Troubleshooting
      </Typography>
      <Typography variant="body2" sx={{ color: "#FFFFFF", mb: 2 }}>
        If you experience issues with swapping LNCH tokens:
        <br />• Confirm that you have sufficient LNCH tokens in your wallet.
        <br />• Verify that you are connected to the correct network.
        <br />• Review the fixed exchange rate to ensure it meets your expectations.
        <br />• Check your wallet for any pending confirmations or errors.
      </Typography>

      {/* Conclusion */}
      <Typography variant="body1" sx={{ color: "#FFFFFF", mt: 3 }}>
        By utilizing a fixed rate for swapping LNCH, CrowdLaunch ensures a stable and predictable ecosystem. This consistency simplifies fee management, tokenization, and staking rewards, giving you greater control and clarity over your transactions.
      </Typography>
    </Container>
  );
};

export default DocsSwapLnch;
